"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./sass/inputText.scss");

var _excluded = ["id", "disabled", "className", "label", "textarea", "value", "placeholder", "tabIndex", "maxLength", "onKeyDown", "onChange", "onClick", "onBlur", "type", "onInput", "min", "max", "icon", "error", "errorMessage", "readOnly"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputText = function InputText(_ref) {
  var id = _ref.id,
      disabled = _ref.disabled,
      className = _ref.className,
      label = _ref.label,
      textarea = _ref.textarea,
      value = _ref.value,
      placeholder = _ref.placeholder,
      tabIndex = _ref.tabIndex,
      maxLength = _ref.maxLength,
      _onKeyDown = _ref.onKeyDown,
      onChange = _ref.onChange,
      _onClick = _ref.onClick,
      onBlur = _ref.onBlur,
      type = _ref.type,
      onInput = _ref.onInput,
      min = _ref.min,
      max = _ref.max,
      icon = _ref.icon,
      error = _ref.error,
      errorMessage = _ref.errorMessage,
      readOnly = _ref.readOnly,
      props = _objectWithoutProperties(_ref, _excluded);

  var textClasses = _defineProperty({
    'input-text': true,
    'input-text--disabled': disabled
  }, "".concat(className), className);

  var inputClasses = {
    'input-icon': icon,
    'input_error': error
  };
  return /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)(textClasses),
    htmlFor: id,
    disabled: disabled
  }, label && /*#__PURE__*/_react.default.createElement("legend", {
    className: "input-label"
  }, label), textarea ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("textarea", _extends({
    className: "input-text-area",
    id: id,
    name: id,
    value: value,
    onChange: onChange,
    onKeyDown: function onKeyDown(e) {
      if (_onKeyDown) {
        _onKeyDown(e);
      }
    },
    onClick: function onClick() {
      if (_onClick) {
        _onClick();
      }
    },
    placeholder: placeholder,
    tabIndex: tabIndex,
    disabled: disabled,
    maxLength: maxLength
  }, props)), /*#__PURE__*/_react.default.createElement("div", {
    className: "font-11 d-none",
    style: {
      color: "#6c6d70",
      marginBottom: "1rem"
    }
  }, "".concat(value.length, " / ").concat(maxLength, " characters"))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "inputContainer"
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: (0, _classnames.default)('input', inputClasses),
    type: type,
    id: id,
    name: id,
    value: value,
    onKeyDown: function onKeyDown(e) {
      if (_onKeyDown) {
        _onKeyDown(e);
      }
    },
    onClick: function onClick() {
      if (_onClick) {
        _onClick();
      }
    },
    onChange: onChange,
    onBlur: onBlur,
    placeholder: placeholder,
    tabIndex: tabIndex,
    disabled: disabled,
    maxLength: maxLength,
    onInput: onInput,
    min: min,
    max: max,
    readOnly: readOnly
  }), error && /*#__PURE__*/_react.default.createElement("div", {
    className: "input_errorMessage"
  }, errorMessage), /*#__PURE__*/_react.default.createElement("div", {
    className: "inputContainer-icon"
  }, icon)));
};

InputText.propTypes = {
  className: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  id: _propTypes.default.string,
  onChange: _propTypes.default.func,
  onKeyPress: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  placeholder: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  value: _propTypes.default.any,
  textarea: _propTypes.default.bool,
  type: _propTypes.default.string,
  maxLength: _propTypes.default.number,
  icon: _propTypes.default.object,
  disabled: _propTypes.default.bool,
  error: _propTypes.default.bool,
  errorMessage: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string]),
  readOnly: _propTypes.default.bool
};
InputText.defaultProps = {
  className: null,
  label: null,
  id: null,
  onChange: null,
  onKeyPress: null,
  placeholder: null,
  value: '',
  textarea: false,
  type: 'text',
  maxLength: null,
  icon: null,
  disabled: false,
  error: false,
  errorMessage: null,
  readOnly: null
};
var _default = InputText;
exports.default = _default;